<template>
  <div class="footer_copy ta-c">
    © 2025 <a href="http://crygrp.cn/">Crygrp</a> All Rights Reserved.
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    activeIndex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  }
};
</script>

<style scoped>
.footer_copy{
  padding: 30px 0;
  font-size: 12px;
  font-weight: 400;
  color: #999;
}
</style>